<template>
  <div class="vue-side-tools">
    <div class="side-navs" v-if="fixedToolNav">
      <p>栏目导航</p>
      <ul class="navs">
        <li @click="navToEle(module.name, index)" class="item" v-for="(module, index) in sideModules" :key="index" v-if="module.is_show !== 0 && module.data.length > 0">
          <i :class="`iconfont el-button--text icon--${module.name}`"></i>
          {{module.name_cn}}
        </li>
      </ul>
    </div>
    <div class="side-qrcode" v-if="fixedToolQrcode">
      <p>微信分享</p>
      <canvas id="scholar-share-qrcode"></canvas>
    </div>
  </div>
</template>
<script>
import QRcode from 'qrcode'

export default {
  props: {
    sideModules: Array
  },
  data () {
    return {
      canvas: ''
    }
  },
  computed: {
    fixedToolNav () {
      return !this.$store.state.config.fixedToolNav
    },
    fixedToolQrcode () {
      return !this.$store.state.config.fixedToolQrcode
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.canvas = document.querySelector('#scholar-share-qrcode')
      this.createQrc()
      this.addScrollEvent()
    })
  },
  methods: {
    createQrc () {
      if (this.fixedToolQrcode) {
        QRcode.toCanvas(this.canvas, location.href, (error) => {
          if (error) {
            console.log(error)
          } else {
            // console.log('success')
          }
        })
      }
    },
    getElementTop (className) {
      var element = this.$(className)
      var actualTop = element.offsetTop
      var current = element.offsetParent
      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    navToEle (name, index) {
      // 拿到元素距离顶部的高度
      // 改变滚动条的高度
      switch (name) {
        case 'career':
          this.setScrollTop('.work-experience')
          break
        case 'intro':
          this.setScrollTop('.personal-profile')
          break
        case 'education':
          this.setScrollTop('.educational-experience')
          break
        case 'papers':
          this.setScrollTop('.research-papers')
          break
        case 'projects':
          this.setScrollTop('.support-project')
          break
        case 'awards':
          this.setScrollTop('.honor-award')
          break
        case 'patents':
          this.setScrollTop('.patent')
          break
        case 'books':
          this.setScrollTop('.books')
          break
        case 'groups':
          this.setScrollTop('.group-organization')
          break
      }
    },
    setScrollTop (ele) {
      var top = this.getElementTop(ele)
      this.$emit('anchorPosition', top - 50)
    },
    $ (el) {
      return document.querySelector(el)
    },
    bindScroll () {
      if (this.fixedToolNav || this.fixedToolQrcode) {
        var eleTop = this.getElementTop('.section-wrap')
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > eleTop - 50) {
          this.$('.side-tools').classList.add('side-tools-fixed')
        } else {
          this.$('.side-tools').classList.remove('side-tools-fixed')
        }
      }
    },
    addScrollEvent () {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent () {
      window.removeEventListener('scroll', this.bindScroll)
    }
  },
  beforeDestroy () {
    this.removeScrollEvent()
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/SideTool/index.vue